import { OnboardingApplicationStatusV2V2x3 } from '../../../api/generated/cz.partners.bank.backofficegateway.fiponboarding.external';

export const ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN = {
	ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN:
		'ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN',
} as const;

export type ExtendedOnboardingApplicationStatus =
	| OnboardingApplicationStatusV2V2x3
	| (typeof ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN)[keyof typeof ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN];

export const ExtendedOnboardingApplicationStatus = {
	...OnboardingApplicationStatusV2V2x3,
	...ALL_ONBOARDING_APPLICATION_STATUSES_CHOSEN,
} as const;
